import React, { FC } from 'react';
import { Button } from 'src/components/Button';
import { Modal } from 'src/components/Modals';
import {
  ButtonsWrapper,
  ContentText,
} from 'src/components/Modals/Delete/styled';

interface DeleteModalProps {
  open: boolean;
  title: string;
  name?: string;
  loading?: boolean;
  description?: string;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteModal: FC<DeleteModalProps> = ({
  title,
  open,
  name,
  loading,
  description,
  onClose,
  onDelete,
}) => (
  <Modal open={open} onClose={onClose} title={title} small>
    <>
      {description ? (
        <ContentText>{description}</ContentText>
      ) : (
        <ContentText>
          This will delete <span>{name}</span>
        </ContentText>
      )}
      <ButtonsWrapper>
        <Button type="button" fullWidth variant="outlined" onClick={onClose}>
          cancel
        </Button>
        <Button
          type="button"
          fullWidth
          variant="contained"
          onClick={onDelete}
          loading={loading}
        >
          Delete
        </Button>
      </ButtonsWrapper>
    </>
  </Modal>
);
